/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconAccessibility({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconAccessibility">  <path fill="currentColor" d="M161.5 166.8c6.4 19.3 17.2 38.5 23.8 61.2H163c-6.8-21-16.5-33.1-21.8-48.9-2.3-6.8-4.7-12.8-6.5-19.7-1.1-4.1-2.8-4.7-5.6-4.7-3.1 0-4.8 2.1-5.5 4.4-6.9 23-16.2 42.4-24.2 68.9H75.2c7.5-28.4 18.1-54.5 25.1-81.5.5-2 .8-3.6.8-5.6 1-18.3.9-27.2.9-45.8-13.7-1.8-44.6-3.3-65-5.1V70c21.2 1.5 58 3.2 73.8 3.7 17.5.6 35-.3 52.5-1.1 12.1-.6 38.6-1.3 56.6-2.4V89c-18.2 1.7-44.6 3.6-56.9 5.2-2.5.3-5.1.3-8.2.8 0 1.5-.1 18.6 0 26.6.2 17.9 1.1 28.2 6.7 45.2zm-33.4-99.6c13.1 0 23.6-10.5 23.6-23.7S141.3 19.9 128 20c-13.3 0-23.6 10.3-23.6 23.6.1 13.2 10.6 23.6 23.7 23.6z" /></svg>
  );
}

IconAccessibility.propTypes = iconPropTypes;
IconAccessibility.defaultProps = iconDefaultProps;
